import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { observable, runInAction, computed, makeObservable, toJS } from "mobx";
import { PlatformType } from "@dp/common";
import moment from "moment";
import i18next from "i18next";
var AnalyticsModel = (_class = /*#__PURE__*/function () {
  _createClass(AnalyticsModel, [{
    key: "_getCategoriesBasedOnMenuProductId",
    // store order number from order details call
    value: function _getCategoriesBasedOnMenuProductId(productID) {
      var _this$_menuListMap, _this$_menuListMap$;

      var breadCrumbSlug = (_this$_menuListMap = this._menuListMap) === null || _this$_menuListMap === void 0 ? void 0 : (_this$_menuListMap$ = _this$_menuListMap["".concat(productID)]) === null || _this$_menuListMap$ === void 0 ? void 0 : _this$_menuListMap$.breadCrumbSlug;
      var breadCrumbs = breadCrumbSlug === null || breadCrumbSlug === void 0 ? void 0 : breadCrumbSlug.split("/");
      return breadCrumbs;
    }
  }, {
    key: "menuListMap",
    set: function set(value) {
      this._menuListMap = value;
    } // This load time to store mount time, to display pickup time if time is not yet set

  }]);

  function AnalyticsModel(platformUtil) {
    _classCallCheck(this, AnalyticsModel);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor, this);

    _initializerDefineProperty(this, "_restaurantDetail", _descriptor2, this);

    _initializerDefineProperty(this, "_cart", _descriptor3, this);

    _initializerDefineProperty(this, "_menuItemDetail", _descriptor4, this);

    _defineProperty(this, "platformUtil", void 0);

    _initializerDefineProperty(this, "_returnWindowDigData", _descriptor5, this);

    _initializerDefineProperty(this, "_waitListData", _descriptor6, this);

    _initializerDefineProperty(this, "_pageAnalyticsDetails", _descriptor7, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor8, this);

    _initializerDefineProperty(this, "_curbsideTransactionDetails", _descriptor9, this);

    _initializerDefineProperty(this, "_curbsideDetails", _descriptor10, this);

    _initializerDefineProperty(this, "_changeErrorPageNameWithoutRD", _descriptor11, this);

    _initializerDefineProperty(this, "_lastOrderDetails", _descriptor12, this);

    _initializerDefineProperty(this, "_userDetails", _descriptor13, this);

    _initializerDefineProperty(this, "_sessionIdData", _descriptor14, this);

    _initializerDefineProperty(this, "_menuListMap", _descriptor15, this);

    _initializerDefineProperty(this, "_orderNumber", _descriptor16, this);

    _initializerDefineProperty(this, "_deliveryEstimate", _descriptor17, this);

    _initializerDefineProperty(this, "_isDeliveryFormDirty", _descriptor18, this);

    _initializerDefineProperty(this, "_isEditDelivery", _descriptor19, this);

    _defineProperty(this, "_loadedTime", null);

    this.platformUtil = platformUtil;
    this._loadedTime = moment();
    makeObservable(this);
  }

  _createClass(AnalyticsModel, [{
    key: "setSessionDetails",
    value: function setSessionDetails(_sessionDetails) {
      var _this = this;

      runInAction(function () {
        _this._sessionDetails = _sessionDetails;
      });
    }
  }, {
    key: "setRestaurantDetailData",
    value: function setRestaurantDetailData(_restaurantDetail) {
      var _this2 = this;

      if (!_restaurantDetail) {
        return;
      }

      runInAction(function () {
        var _restaurantDetail$res, _restaurantDetail$con, _restaurantDetail$con2, _restaurantDetail$con3, _restaurantDetail$con4, _restaurantDetail$con5;

        _this2._restaurantDetail = {
          locationId: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : _restaurantDetail.atgRestaurantId,
          restaurantNum: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : (_restaurantDetail$res = _restaurantDetail.restaurantNumber) === null || _restaurantDetail$res === void 0 ? void 0 : _restaurantDetail$res.toString(),
          locationName: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : _restaurantDetail.restaurantName,
          locationState: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : (_restaurantDetail$con = _restaurantDetail.contactDetail) === null || _restaurantDetail$con === void 0 ? void 0 : (_restaurantDetail$con2 = _restaurantDetail$con.address) === null || _restaurantDetail$con2 === void 0 ? void 0 : _restaurantDetail$con2.stateCode,
          locationZip: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : (_restaurantDetail$con3 = _restaurantDetail.contactDetail) === null || _restaurantDetail$con3 === void 0 ? void 0 : (_restaurantDetail$con4 = _restaurantDetail$con3.address) === null || _restaurantDetail$con4 === void 0 ? void 0 : (_restaurantDetail$con5 = _restaurantDetail$con4.zipCode) === null || _restaurantDetail$con5 === void 0 ? void 0 : _restaurantDetail$con5.toString()
        };
      });
    }
  }, {
    key: "setCartData",
    value: function setCartData(_cart) {
      var _this3 = this;

      runInAction(function () {
        _this3._cart = _cart;
      }); // Order number is only recieved on order details call.
      // making sure to store it so that it doesn't clear out after cart action calls

      if (_cart !== null && _cart !== void 0 && _cart.orderNumber) {
        runInAction(function () {
          _this3._orderNumber = _cart === null || _cart === void 0 ? void 0 : _cart.orderNumber;
        });
      }
    }
  }, {
    key: "setMenuItemDetailData",
    value: function setMenuItemDetailData(item) {
      var _this4 = this;

      runInAction(function () {
        _this4._menuItemDetail = item;
      });
    }
  }, {
    key: "setReturnWindowDigData",
    value: function setReturnWindowDigData(returnWindowDigData) {
      this._returnWindowDigData = returnWindowDigData;
    }
  }, {
    key: "setChangeErrorPageNameWithoutRD",
    value: function setChangeErrorPageNameWithoutRD(_val) {
      var _this5 = this;

      runInAction(function () {
        _this5._changeErrorPageNameWithoutRD = _val;
      });
    }
  }, {
    key: "getOrderTypeString",
    value: function getOrderTypeString(orderTypeNumber) {
      switch (orderTypeNumber) {
        case 0:
          return "togo";

        case 1:
          return "gift card";

        case 2:
          return "catering delivery";

        case 3:
          return "catering pickup";

        case 5:
          return "order ahead";

        case 6:
          return "togo delivery";

        default:
          return "";
      }
    }
  }, {
    key: "setUserDetails",
    value: function setUserDetails(userDetails) {
      var _this6 = this;

      runInAction(function () {
        _this6._userDetails = userDetails;
      });
    }
  }, {
    key: "setLastOrderDetails",
    value: function setLastOrderDetails(orderDetails) {
      var _this7 = this;

      runInAction(function () {
        _this7._lastOrderDetails = orderDetails;
      });
    }
  }, {
    key: "setDeliveryEstimate",
    value: function setDeliveryEstimate(estimate) {
      var _this8 = this;

      runInAction(function () {
        return _this8._deliveryEstimate = estimate;
      });
    }
  }, {
    key: "dispatchLocationSearchModalEvent",

    /************************************************* MENU LIST EVENTS *****************************************/
    value: function dispatchLocationSearchModalEvent(coords) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "LocationSearchModal", {
        coordinates: (coords === null || coords === void 0 ? void 0 : coords.latitude) + ", " + (coords === null || coords === void 0 ? void 0 : coords.longitude)
      });
    }
  }, {
    key: "dispatchGetRecommendationsEvent",
    value: function dispatchGetRecommendationsEvent(restaurantId, restaurantNum, recommendations, type) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "GetRecommendations", {
        location: {
          restaurantId: restaurantId,
          restNum: restaurantNum
        },
        numberOfRecommendations: recommendations === null || recommendations === void 0 ? void 0 : recommendations.length,
        recommended: recommendations,
        type: type
      });
    }
  }, {
    key: "dispatchLocationChangedEvent",
    value: function dispatchLocationChangedEvent(restaurantNum, prevResturantNumber, isAsapSelected) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "LocationChange", {
        location: {
          newRestaurantNumber: restaurantNum,
          prevResturantNumber: prevResturantNumber,
          restNum: restaurantNum,
          changed: true
        },
        asap: isAsapSelected
      });
    }
  }, {
    key: "dispatchSmartRecommendationsForCheckoutEvent",
    value: function dispatchSmartRecommendationsForCheckoutEvent(restaurantId, restaurantNum, recommendations) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "SmartRecommendationsForCheckout", {
        location: {
          restaurantId: restaurantId,
          restNum: restaurantNum
        },
        numberOfRecommendations: recommendations === null || recommendations === void 0 ? void 0 : recommendations.length,
        recommended: recommendations,
        type: "shoppingcart"
      });
    }
  }, {
    key: "dispatchFromSmartRecommendationEvent",
    value: function dispatchFromSmartRecommendationEvent() {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "AddedFromSmartRecommendedModal", {
        itemAdded: true
      });
    }
  }, {
    key: "dispatchUnavailableItemsEvent",
    value: function dispatchUnavailableItemsEvent(restaurantId, restaurantNum, _86Items) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "UnavailableItems", {
        location: {
          restaurantId: restaurantId,
          restNum: restaurantNum
        },
        unavailableItems: _86Items
      });
    }
  }, {
    key: "dispatchSetLocationDataEvent",
    value: function dispatchSetLocationDataEvent(latitude, longitude) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "SetLocationData", {
        latitude: latitude,
        longitude: longitude
      });
    }
  }, {
    key: "dispatchSetOrderHistoryDataEvent",
    value: function dispatchSetOrderHistoryDataEvent(orderHistory) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "SetOrderHistoryData", {
        orderHistory: orderHistory
      });
    }
  }, {
    key: "dispatchSearchMyLocationEvent",
    value: function dispatchSearchMyLocationEvent(coordinates, numberOfResults, restaurantIds) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "SearchMyLocation", {
        coordinates: coordinates[0] + ", " + coordinates[1],
        numberOfResults: numberOfResults,
        restaurantIds: restaurantIds
      });
    }
  }, {
    key: "dispatchFetchTimesEvent",
    value: function dispatchFetchTimesEvent(resturantId, restaurantNum, selectedCalendarDate, orderType, isAsapSelected) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "FetchTimes", {
        location: {
          restaurantId: resturantId,
          restNum: restaurantNum
        },
        selectedCalendarDate: selectedCalendarDate,
        orderType: orderType,
        asap: isAsapSelected
      });
    }
  }, {
    key: "dispatchSetOrderPickupTimeEvent",
    value: function dispatchSetOrderPickupTimeEvent(date, time, isAsapSelected) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "SetOrderPickupTime", {
        date: date,
        time: time,
        asap: isAsapSelected
      });
    }
  }, {
    key: "dispatchSetOrderPickupTimeAndLocationEvent",
    value: function dispatchSetOrderPickupTimeAndLocationEvent(restaurantId, restaurantNum, date, time, isAsapSelected, serializedCartId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "SetOrderPickupTimeAndLocation", _objectSpread(_objectSpread({}, serializedCartId), {}, {
        location: {
          restaurantId: restaurantId,
          restNum: restaurantNum
        },
        date: date,
        time: time,
        asap: isAsapSelected
      }));
    }
  }, {
    key: "dispatchSaveToFavoritesEvent",
    value: function dispatchSaveToFavoritesEvent(giftListId, giftListItemId, productId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "SaveToFavorites", {
        giftListId: giftListId,
        giftListItemId: giftListItemId,
        productId: productId
      });
    }
  }, {
    key: "dispatchRemoveFromFavoritesEvent",
    value: function dispatchRemoveFromFavoritesEvent(giftListId, giftListItemId, productId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "RemoveFromFavorites", {
        giftListId: giftListId,
        giftListItemId: giftListItemId,
        productId: productId
      });
    }
  }, {
    key: "dispatchLoadMenuDetailEvent",
    value: function dispatchLoadMenuDetailEvent(restaurantId, restaurantNum, menuType, pageType, primaryCategory, subCategory1, subCategory2, subCategory3, basePrice, productId, productName, productDetails, recommended, reorder, duplicate, serializedCartId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "LoadMenuDetail", _objectSpread(_objectSpread({}, serializedCartId), {}, {
        location: {
          restaurantId: restaurantId,
          restNum: restaurantNum
        },
        product: [{
          category: {
            menuType: menuType,
            pageType: pageType,
            primaryCategory: primaryCategory,
            subCategory1: subCategory1,
            subCategory2: subCategory2,
            subCategory3: subCategory3
          },
          price: {
            basePrice: basePrice
          },
          productInfo: {
            productId: productId,
            productName: productName,
            productDetails: productDetails
          },
          recommended: recommended,
          reorder: reorder,
          duplicate: duplicate
        }]
      }));
    }
  }, {
    key: "dispatchLocationConfirmChangeEvent",
    value: function dispatchLocationConfirmChangeEvent(restaurantId, restaurantNum, locationChanged, pickupDate, pickupTime, dateTimeChanged, orderType, orderTypeChanged) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "LocationConfirmChange", {
        location: {
          restaurantId: restaurantId,
          restNum: restaurantNum,
          locationChanged: locationChanged
        },
        dateTime: {
          pickupDate: pickupDate,
          pickupTime: pickupTime,
          dateTimeChanged: dateTimeChanged
        },
        orderType: orderType,
        orderTypeChanged: orderTypeChanged
      });
    }
  }, {
    key: "dispatchTimeConfirmChangeEvent",
    value: function dispatchTimeConfirmChangeEvent(date, time, isAsapSelected) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "TimeConfirmChange", {
        date: date,
        time: time,
        asap: isAsapSelected
      });
    }
  }, {
    key: "dispatchOrderErrorEvent",
    value: function dispatchOrderErrorEvent(faultCode, faultDescription) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "OrderError", {
        faultCode: faultCode,
        faultDescription: faultDescription
      });
    }
  }, {
    key: "dispatchWLErrorEvent",
    value: function dispatchWLErrorEvent(faultCode, faultDescription) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "errorCode", {
        faultCode: faultCode,
        faultDescription: faultDescription
      });
    }
  }, {
    key: "dispatchProductDetailsModalEvent",
    value: function dispatchProductDetailsModalEvent(type, productId, productSku, productName, recommended) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ProductDetailsModal", {
        menuType: type,
        productInfo: {
          productId: productId,
          productSku: productSku,
          productName: productName,
          recommended: recommended
        }
      });
    }
  }, {
    key: "dispatchUpdateCartEvent",
    value: function dispatchUpdateCartEvent(productId, sku, quantity) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "UpdateCart", {
        productId: productId,
        sku: sku,
        quantity: quantity
      });
    }
  }, {
    key: "dispatchDeleteCartItemEvent",
    value: function dispatchDeleteCartItemEvent(restaurantId, restaurantNum, basePrice, productId, productSku, productName, breadsticks, totalBreadCount) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "DeleteCartItem", {
        location: {
          restaurantId: restaurantId,
          restNum: restaurantNum
        },
        product: [{
          price: {
            basePrice: basePrice
          },
          productInfo: {
            productId: productId,
            productSku: productSku,
            productName: productName
          }
        }],
        breadsticks: breadsticks,
        totalBreadCount: totalBreadCount
      });
    }
  }, {
    key: "dispatchQuickAddEvent",
    value: function dispatchQuickAddEvent(menuType, pageType, primaryCategory, subCategory1, subCategory2, subCategory3, productId, productName, sku, basePrice, currency, recommended, reorder, serializedCartId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "QuickAdd", _objectSpread(_objectSpread({}, serializedCartId), {}, {
        product: [{
          category: {
            menuType: menuType,
            pageType: pageType,
            primaryCategory: primaryCategory,
            subCategory1: subCategory1,
            subCategory2: subCategory2,
            subCategory3: subCategory3
          },
          productInfo: {
            productId: productId,
            productName: productName,
            sku: sku,
            basePrice: basePrice,
            currency: currency
          },
          recommended: recommended,
          reorder: reorder
        }]
      }));
    }
  }, {
    key: "dispatchAddToCartEvent",
    value: function dispatchAddToCartEvent(menuType, pageType, primaryCategory, subCategory1, subCategory2, subCategory3, basePrice, totalPrice, currency, addOnArray, productId, productName, productDetails, productSku, recommended, reorder, isDuplicate, breadsticks, totalBreadCount, serializedCartId, itemAddLocation) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "AddToCart", _objectSpread(_objectSpread({}, serializedCartId), {}, {
        product: [{
          category: {
            menuType: menuType,
            pageType: pageType,
            primaryCategory: primaryCategory,
            subCategory1: subCategory1,
            subCategory2: subCategory2,
            subCategory3: subCategory3
          },
          price: {
            basePrice: basePrice,
            totalPrice: totalPrice,
            currency: currency
          },
          addOns: {
            addOnArr: addOnArray
          },
          productInfo: {
            productId: productId,
            productName: productName,
            productDetails: productDetails,
            productSku: productSku
          },
          recommended: recommended,
          reorder: reorder,
          isDuplicate: isDuplicate
        }],
        breadsticks: breadsticks,
        totalBreadCount: totalBreadCount,
        cartAddLocation: itemAddLocation
      }));
    }
  }, {
    key: "dispatchPageViewEvent",
    value: function dispatchPageViewEvent(pageName, mobilePayType) {
      var payload = {
        pageName: pageName
      };

      if (mobilePayType) {
        payload["mobilePayType"] = mobilePayType;
      }

      this.platformUtil.dispatchEvent("AnalyticsEvent", "PageView", payload);
    }
  }, {
    key: "dispatchPageViewSourceEvent",
    value: function dispatchPageViewSourceEvent(pageName, pageSource, orderId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "PageView", {
        pageName: pageName,
        pageSource: pageSource,
        orderId: orderId
      });
    }
  }, {
    key: "dispatchDisplayModalEvent",
    value: function dispatchDisplayModalEvent(modalIntent, modalContent, modalName, productId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "DisplayModal", {
        modalIntent: modalIntent,
        modalContent: modalContent,
        modalName: modalName,
        productId: productId
      });
    }
  }, {
    key: "dispatchShowHideCartEvent",
    value: function dispatchShowHideCartEvent(showCart) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "CartView", {
        showCart: showCart
      });
    }
  }, {
    key: "dispatchOrderConfirmation",
    value: function dispatchOrderConfirmation(orderId, restId, restNum, specialInstruction) {
      this.platformUtil.dispatchEvent("AnalyticsTransaction", "OrderConfirmation", {
        restId: restId,
        restNum: restNum,
        specialInstruction: specialInstruction
      });
    }
  }, {
    key: "dispatchPurchase",
    value: function dispatchPurchase() {
      this.platformUtil.dispatchEvent("AnalyticsTransaction", "Purchase", {});
    }
  }, {
    key: "dispatchOrderConfirmationAccCreat",
    value: function dispatchOrderConfirmationAccCreat(zipCode, state, country, birthYear, restId, restaurantNum) {
      this.platformUtil.dispatchEvent("AnalyticsForm", "CreateAccountComplete", {
        zipCode: zipCode,
        state: state,
        country: country,
        birthYear: birthYear,
        restId: restId,
        restNum: restaurantNum,
        hasAddress: restId ? "true" : "false"
      });
    }
  }, {
    key: "dispatchMobilePay",
    value: function dispatchMobilePay(baseCheck, discount, paymentType, tax, tip, total) {
      this.platformUtil.dispatchEvent("AnalyticsForm", "MobilePay", {
        baseCheck: baseCheck,
        discount: discount,
        paymentType: paymentType,
        tax: tax,
        tip: tip,
        total: total
      });
    }
  }, {
    key: "dispatchMobilePayComplete",
    value: function dispatchMobilePayComplete(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "mobilePayComplete", payload);
    }
  }, {
    key: "dispatchMobilePayScan",
    value: function dispatchMobilePayScan(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "mobilePayScan", payload);
    }
  }, {
    key: "dispatchMobilePayError",
    value: function dispatchMobilePayError(errorPayload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "mobilePayError", errorPayload);
    }
  }, {
    key: "dispatchMobilePayCTAClick",
    value: function dispatchMobilePayCTAClick(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "mobilePayCTAClick", payload);
    }
  }, {
    key: "dispatchWaitlistComplete",
    value: function dispatchWaitlistComplete(waitTime, partySize, waitlist_token, restNum) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "waitlistComplete", {
        waitTime: waitTime,
        partySize: partySize,
        waitlist_token: waitlist_token,
        restNum: restNum
      });
    }
  }, {
    key: "dispatchWaitlistPartyUpdate",
    value: function dispatchWaitlistPartyUpdate(waitTime, partySize, waitlist_token) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "waitlistPartyUpdate", {
        waitTime: waitTime,
        partySize: partySize,
        waitlist_token: waitlist_token
      });
    }
  }, {
    key: "dispatchCartViewEvent",
    value: function dispatchCartViewEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "CartView", payload);
    }
  }, {
    key: "dispatchCheckoutEvent",
    value: function dispatchCheckoutEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "Checkout", payload);
    }
  }, {
    key: "dispatchMenuBrowseEvent",
    value: function dispatchMenuBrowseEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "MenuBrowse", payload);
    }
  }, {
    key: "dispatchReservations",
    value: function dispatchReservations(reservationType, reservationLocation, reservationTime, reservationGuests, reservationOccasion, reservationDate, dayOfWeek, reservationPurpose) {
      this.platformUtil.dispatchEvent("AnalyticsForm", "Reservations", {
        reservationType: reservationType,
        reservationLocation: reservationLocation,
        reservationTime: reservationTime,
        reservationGuests: reservationGuests,
        reservationOccasion: reservationOccasion,
        reservationDate: reservationDate,
        dayOfWeek: dayOfWeek,
        reservationPurpose: reservationPurpose
      });
    }
  }, {
    key: "dispatchEClubEvent",
    value: function dispatchEClubEvent(brands, signupChannel) {
      this.platformUtil.dispatchEvent("AnalyticsForm", "eClubOptinComplete", {
        brands: brands !== null && brands !== void 0 ? brands : [],
        signupChannel: signupChannel
      });
    }
  }, {
    key: "processEClubEvent",
    value: function () {
      var _processEClubEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(brands, signupChannel) {
        var brandValForEvents;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (brands && brands.length > 0) {
                  brandValForEvents = brands.map(function (el) {
                    switch (el) {
                      case "general-olive-garden-logo":
                      case "general-og-Logo":
                        return "OG";

                      case "general-longhorn-logo":
                        return "LH";

                      case "general-cheddars-logo":
                        return "CSK";

                      case "general-seasons-logo":
                        return "S52";

                      case "general-bahama-breeze-logo":
                        return "BB";

                      case "general-yard-house-logo":
                      case "general-yard-logo":
                        return "YH";

                      case "general-eddie-vs-logo":
                      case "general-eddie-logo":
                        return "EV";

                      case "general-the-capital-grill-logo":
                      case "general-capital-logo":
                        return "TCG";

                      case "general-the-capital-burger-logo":
                        return "TCB";

                      default:
                        return el;
                    }
                  });
                  this.dispatchEClubEvent(brandValForEvents, signupChannel);
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function processEClubEvent(_x, _x2) {
        return _processEClubEvent.apply(this, arguments);
      }

      return processEClubEvent;
    }()
  }, {
    key: "dispatchMenuSearchAbTestConfirmation",
    value: function dispatchMenuSearchAbTestConfirmation(isMenuSearchEnabled) {
      this.platformUtil.dispatchEvent("AnalyticsForm", "MenuSearchABTest", {
        experience: isMenuSearchEnabled
      });
    }
  }, {
    key: "dispatchSearchIconClickedConfirmation",
    value: function dispatchSearchIconClickedConfirmation() {
      this.platformUtil.dispatchEvent("AnalyticsForm", "MenuSearchClicked", {});
    }
  }, {
    key: "dispatchKeywordSearchConfirmation",
    value: function dispatchKeywordSearchConfirmation(searchText, isSuggested, isMenuSearchResultsReturned) {
      this.platformUtil.dispatchEvent("AnalyticsForm", "MenuSearchKeywordEvent", {
        menuSearchTerm: searchText,
        menuSearchResultsReturned: isMenuSearchResultsReturned,
        isSuggested: isSuggested
      });
    }
  }, {
    key: "dispatchSearchResultItemClickedConfirmation",
    value: function dispatchSearchResultItemClickedConfirmation(searchText, productId, productName, productPrimaryCategory, productSubCategory1, productSubCategory2) {
      this.platformUtil.dispatchEvent("AnalyticsForm", "MenuSearchResultClick", {
        menuSearchTerm: searchText,
        productId: productId,
        productName: productName,
        primaryCategory: productPrimaryCategory,
        subCategory1: productSubCategory1,
        subCategory2: productSubCategory2
      });
    }
  }, {
    key: "setWaitListData",
    value: function setWaitListData(_waitListData) {
      var _this9 = this;

      runInAction(function () {
        _this9._waitListData = _waitListData;
      });
    }
  }, {
    key: "setPageAnalyticsDetails",
    value: function setPageAnalyticsDetails(_analyticsDetails) {
      var _this10 = this;

      runInAction(function () {
        _this10._pageAnalyticsDetails = _analyticsDetails;
      });
    }
  }, {
    key: "setCurbsideTransaction",
    value: function setCurbsideTransaction(_transaction) {
      var _this11 = this;

      runInAction(function () {
        _this11._curbsideTransactionDetails = _transaction;
      });
    }
  }, {
    key: "setCurbsideAnalyticsData",
    value: function setCurbsideAnalyticsData(_data) {
      var _this12 = this;

      runInAction(function () {
        _this12._curbsideDetails = _data;
      });
    }
  }, {
    key: "setAppAttributes",
    value: function setAppAttributes(_val) {
      var _this13 = this;

      runInAction(function () {
        _this13._appAttributes = _val;
      });
    }
  }, {
    key: "dispatchPermissionsForGeoDetect",
    value: function dispatchPermissionsForGeoDetect(pushNotificationEnabled, locationServiceStatus, restNum) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "PermissionsForGeoDetect", {
        pushNotificationEnabled: pushNotificationEnabled.toString(),
        LocationServiceEnabled: locationServiceStatus,
        restNum: restNum
      });
    }
  }, {
    key: "dispatchPushNotificationEnabled",
    value: function dispatchPushNotificationEnabled() {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "CurbsideCheckin", {
        pushNotificationEnabled: "true"
      });
    }
  }, {
    key: "dispatchCurbsideCheckinEvent",
    value: function dispatchCurbsideCheckinEvent(pageName, payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "PageView", _objectSpread({
        pageName: pageName
      }, payload));
    }
  }, {
    key: "dispatchCurbsideCheckinErrorEvent",
    value: function dispatchCurbsideCheckinErrorEvent(pageName, payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ErrorPage", _objectSpread({
        pageName: pageName
      }, payload));
    }
  }, {
    key: "dispatchCurbsideCTAClick",
    value: function dispatchCurbsideCTAClick(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "curbsideCheckInCTAClick", payload);
    }
  }, {
    key: "dispatchReservationStartEvent",
    value: function dispatchReservationStartEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationStart", payload);
    }
  }, {
    key: "dispatchFormStartEvent",
    value: function dispatchFormStartEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "Form Start", payload);
    }
  }, {
    key: "dispatchFormSubmitEvent",
    value: function dispatchFormSubmitEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "Form Submit", payload);
    }
  }, {
    key: "dispatchReservationSubmitEvent",
    value: function dispatchReservationSubmitEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationSubmit", payload);
    }
  }, {
    key: "dispatchReservationCompleteEvent",
    value: function dispatchReservationCompleteEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationComplete", payload);
    }
  }, {
    key: "dispatchReservationChangeLocationEvent",
    value: function dispatchReservationChangeLocationEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationChangeLocation", payload);
    }
  }, {
    key: "dispatchReservationInformationEvent",
    value: function dispatchReservationInformationEvent() {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationInformation", {});
    }
  }, {
    key: "dispatchReservationCancelEvent",
    value: function dispatchReservationCancelEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationCancel", payload);
    }
  }, {
    key: "dispatchReservationConfirmationEvent",
    value: function dispatchReservationConfirmationEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationConfirmation", payload);
    }
  }, {
    key: "dispatchReservationTimeNotAvailableEvent",
    value: function dispatchReservationTimeNotAvailableEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationTimeNotAvailable", payload);
    }
  }, {
    key: "dispatchEditReservationConfirmationEvent",
    value: function dispatchEditReservationConfirmationEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "EditReservation", payload);
    }
  }, {
    key: "dispatchPopupAppearedEvent",
    value: function dispatchPopupAppearedEvent(modalName, subTitle, restNum, additionalMessages, i18ResourceString, normalHtml, params) {
      var messages = []; // to remove html tags from text

      var regex = /(<([^>]+)>)/gi;

      if (subTitle) {
        messages.push(subTitle);
      }

      if (additionalMessages) {
        messages.push.apply(messages, _toConsumableArray(additionalMessages));
      }

      if (i18ResourceString) {
        var i18nMessage = i18next.t(i18ResourceString, _objectSpread({
          interpolation: {
            prefix: "${",
            suffix: "}"
          }
        }, params));
        messages.push(i18nMessage === null || i18nMessage === void 0 ? void 0 : i18nMessage.replace(regex, ""));
      }

      if (normalHtml) {
        messages.push(normalHtml === null || normalHtml === void 0 ? void 0 : normalHtml.replace(regex, ""));
      }

      var modalText = messages.join(", ");
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ModalPageview", {
        modalName: modalName,
        modaltext: modalText,
        restNum: restNum
      });
    }
  }, {
    key: "dispatchReservationTimeNotAvailable",
    value: function dispatchReservationTimeNotAvailable(reservationLocation, reservationTime, reservationDate, reservationGuests, userProfileId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationTimeNotAvailable", {
        reservationLocation: reservationLocation ? reservationLocation === null || reservationLocation === void 0 ? void 0 : reservationLocation.toString() : null,
        reservationTime: reservationTime,
        reservationDate: reservationDate,
        reservationGuests: reservationGuests ? reservationGuests === null || reservationGuests === void 0 ? void 0 : reservationGuests.toString() : null,
        userProfileId: userProfileId
      });
    }
  }, {
    key: "dispatchViewWineListEvent",
    value: function dispatchViewWineListEvent() {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "viewWineList", {});
    }
  }, {
    key: "dispatchCallForVIPReservationEvent",
    value: function dispatchCallForVIPReservationEvent() {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "generalClick", {});
    }
  }, {
    key: "dispatchWineLockerAddedItem",
    value: function dispatchWineLockerAddedItem(wineItemName, wineItemPrice) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "wineLockerAddedItem", {
        wineItemName: wineItemName,
        wineItemPrice: wineItemPrice ? wineItemPrice === null || wineItemPrice === void 0 ? void 0 : wineItemPrice.toString() : null
      });
    }
  }, {
    key: "dispatchWineLockerGiftItem",
    value: function dispatchWineLockerGiftItem(userProfileId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "wineLockerGiftItem", {
        userProfileId: userProfileId
      });
    }
  }, {
    key: "dispatchWineLockerAddedKeyholder",
    value: function dispatchWineLockerAddedKeyholder(userProfileId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "wineLockerAddedKeyholder", {
        userProfileId: userProfileId
      });
    }
  }, {
    key: "dispatchOrderConfirmationTakeSurvey",
    value: function dispatchOrderConfirmationTakeSurvey(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "generalClick", payload, "ACTION");
    }
  }, {
    key: "dispatchReservationErrorEvent",
    value: function dispatchReservationErrorEvent(faultCode, faultDescription) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "errorCode", {
        faultCode: faultCode,
        faultDescription: faultDescription
      });
    }
  }, {
    key: "dispatchUserChangeLocationEvent",
    value: function dispatchUserChangeLocationEvent() {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "USER_CHANGE_LOCATION", {});
    }
  }, {
    key: "dispatchUserChangeLocationSuccessEvent",
    value: function dispatchUserChangeLocationSuccessEvent(_ref) {
      var previousRestNumber = _ref.previousRestNumber,
          currentRestNumber = _ref.currentRestNumber;
      this.platformUtil.dispatchEvent("AnalyticsEvent", "USER_CHANGE_LOCATION_SUCCESS", {
        previousRestNumber: previousRestNumber || "",
        currentRestNumber: currentRestNumber,
        changeLocation: true
      });
    }
  }, {
    key: "dispatchAPIError",
    value: function dispatchAPIError(error) {
      try {
        var _error$request, _error$request2, _this$platformUtil, _this$platformUtil$di, _error$response, _error$response$data, _error$response$data$, _error$response$data$2, _error$response2, _error$response2$data, _error$response2$data2, _error$response2$data3, _error$response3, _error$response3$data;

        var url = new URL((error === null || error === void 0 ? void 0 : (_error$request = error.request) === null || _error$request === void 0 ? void 0 : _error$request.qurl) || (error === null || error === void 0 ? void 0 : (_error$request2 = error.request) === null || _error$request2 === void 0 ? void 0 : _error$request2.responseURL));
        (_this$platformUtil = this.platformUtil) === null || _this$platformUtil === void 0 ? void 0 : (_this$platformUtil$di = _this$platformUtil.dispatchEvent) === null || _this$platformUtil$di === void 0 ? void 0 : _this$platformUtil$di.call(_this$platformUtil, "AnalyticsEvent", "errorCode", {
          faultCode: error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.errors) === null || _error$response$data$ === void 0 ? void 0 : (_error$response$data$2 = _error$response$data$[0]) === null || _error$response$data$2 === void 0 ? void 0 : _error$response$data$2.errorCode,
          faultDescription: error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : (_error$response2$data2 = _error$response2$data.errors) === null || _error$response2$data2 === void 0 ? void 0 : (_error$response2$data3 = _error$response2$data2[0]) === null || _error$response2$data3 === void 0 ? void 0 : _error$response2$data3.errorMessage,
          apiName: (url === null || url === void 0 ? void 0 : url.pathname) + (url === null || url === void 0 ? void 0 : url.search),
          statusCode: error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$data = _error$response3.data) === null || _error$response3$data === void 0 ? void 0 : _error$response3$data.statusCode
        });
      } catch (_unused) {}
    }
  }, {
    key: "setSessionIdData",
    value: function setSessionIdData(_data) {
      var _this14 = this;

      runInAction(function () {
        _this14._sessionIdData = _data;
      });
    }
  }, {
    key: "dispatchInitialTogoDeliveryModalEvent",
    value: function dispatchInitialTogoDeliveryModalEvent() {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "EXT_DEL_POPUP_SHOWN", {});
    }
  }, {
    key: "dispatchTogoDeliveryQuoteSubmittedEvent",
    value: function dispatchTogoDeliveryQuoteSubmittedEvent(analyticsPayload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "EXT_DEL_ADDRESS_QUOTE_SUBMITTED", {
        analyticsPayload: analyticsPayload
      });
    }
  }, {
    key: "dispatchTogoDeliveryQuoteShown",
    value: function dispatchTogoDeliveryQuoteShown(analyticsPayload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ITEMIZED_QUOTE_SHOWN", {
        analyticsPayload: analyticsPayload
      });
    }
  }, {
    key: "dispatchTogoDeliveryErrorEvent",
    value: function dispatchTogoDeliveryErrorEvent(faultCode, faultDescription) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "errorCode", {
        faultCode: faultCode,
        faultDescription: faultDescription
      });
    }
  }, {
    key: "dispatchOrderTypeChangeEvent",
    value: function dispatchOrderTypeChangeEvent(analyticsPayload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ORDER_TYPE_CHANGE", {
        analyticsPayload: analyticsPayload
      });
    }
  }, {
    key: "cart",
    get: function get() {
      var _this15 = this;

      var cart = null;
      var sumOfBreadsticks = 0;

      try {
        var _this$_cart, _this$_cart2, _moment, _this$_cart3, _moment2, _this$_cart4, _this$_cart5, _this$_cart5$commerce, _this$_cart5$commerce2, _this$_cart$priceInfo, _this$_cart6, _this$_cart6$priceInf, _this$_cart7, _this$_cart7$priceInf, _this$_cart8, _this$_cart9, _this$_cart10, _this$_cart11;

        cart = {
          attributes: {
            orderSubType: this._cart ? "new" : "",
            //TODO: "new" or "reorder" //check dataLayerJSON
            orderType: this.getOrderTypeString((_this$_cart = this._cart) === null || _this$_cart === void 0 ? void 0 : _this$_cart.orderType),
            pickupDate: ((_this$_cart2 = this._cart) === null || _this$_cart2 === void 0 ? void 0 : _this$_cart2.pickupDate) || (this !== null && this !== void 0 && this._cart ? (_moment = moment(this === null || this === void 0 ? void 0 : this._loadedTime)) === null || _moment === void 0 ? void 0 : _moment.format("MM/DD/YYYY") : ""),
            pickupTime: ((_this$_cart3 = this._cart) === null || _this$_cart3 === void 0 ? void 0 : _this$_cart3.pickupTime) || (this !== null && this !== void 0 && this._cart ? (_moment2 = moment(this._loadedTime)) === null || _moment2 === void 0 ? void 0 : _moment2.format("hh:mm A") : "")
          },
          cartID: ((_this$_cart4 = this._cart) === null || _this$_cart4 === void 0 ? void 0 : _this$_cart4.orderNumber) || this._orderNumber || "",
          item: ((_this$_cart5 = this._cart) === null || _this$_cart5 === void 0 ? void 0 : (_this$_cart5$commerce = _this$_cart5.commerceItems) === null || _this$_cart5$commerce === void 0 ? void 0 : (_this$_cart5$commerce2 = _this$_cart5$commerce.map) === null || _this$_cart5$commerce2 === void 0 ? void 0 : _this$_cart5$commerce2.call(_this$_cart5$commerce, function (item) {
            var _item$subItem, _item$subItem$map, _ref2, _item$priceInfo, _item$subItem2;

            var addOnsPrice = item === null || item === void 0 ? void 0 : (_item$subItem = item.subItem) === null || _item$subItem === void 0 ? void 0 : (_item$subItem$map = _item$subItem.map(function (addOnPrice) {
              return addOnPrice === null || addOnPrice === void 0 ? void 0 : addOnPrice.unitPrice;
            })) === null || _item$subItem$map === void 0 ? void 0 : _item$subItem$map.reduce(function (prev, curr) {
              return prev + curr;
            }, 0);
            var basePrice = parseFloat((_ref2 = (item === null || item === void 0 ? void 0 : (_item$priceInfo = item.priceInfo) === null || _item$priceInfo === void 0 ? void 0 : _item$priceInfo.listPrice) - addOnsPrice) === null || _ref2 === void 0 ? void 0 : _ref2.toFixed(2));
            var addOnsInfo = item === null || item === void 0 ? void 0 : (_item$subItem2 = item.subItem) === null || _item$subItem2 === void 0 ? void 0 : _item$subItem2.map(function (addOnItem) {
              return [{
                breadCount: (item === null || item === void 0 ? void 0 : item.quantity) * (addOnItem === null || addOnItem === void 0 ? void 0 : addOnItem.breadCount),
                nameproductName: addOnItem === null || addOnItem === void 0 ? void 0 : addOnItem.displayName,
                productDescription: addOnItem === null || addOnItem === void 0 ? void 0 : addOnItem.description,
                productId: addOnItem === null || addOnItem === void 0 ? void 0 : addOnItem.productId,
                price: addOnItem === null || addOnItem === void 0 ? void 0 : addOnItem.unitPrice
              }];
            });
            sumOfBreadsticks += (item === null || item === void 0 ? void 0 : item.quantity) * (item === null || item === void 0 ? void 0 : item.breadCount);

            if (item !== null && item !== void 0 && item.subItem) {
              var _item$subItem3;

              (_item$subItem3 = item.subItem) === null || _item$subItem3 === void 0 ? void 0 : _item$subItem3.forEach(function (sItem) {
                var subItemBreadCount = sItem === null || sItem === void 0 ? void 0 : sItem.breadCount;
                sumOfBreadsticks += (item === null || item === void 0 ? void 0 : item.quantity) * subItemBreadCount;
              });
            }

            var categories = _this15._getCategoriesBasedOnMenuProductId(item === null || item === void 0 ? void 0 : item.productId);

            return {
              breadCount: (item === null || item === void 0 ? void 0 : item.quantity) * (item === null || item === void 0 ? void 0 : item.breadCount),
              category: {
                primaryCategory: "menu",
                subCategory1: (categories === null || categories === void 0 ? void 0 : categories[0]) || "",
                subCategory2: (categories === null || categories === void 0 ? void 0 : categories[1]) || ""
              },
              price: {
                basePrice: basePrice,
                currency: "USD"
              },
              productInfo: {
                productID: item === null || item === void 0 ? void 0 : item.productId,
                productName: item === null || item === void 0 ? void 0 : item.displayName,
                recommended: null,
                sku: item === null || item === void 0 ? void 0 : item.catalogRefId,
                modifiers: addOnsInfo
              },
              quantity: item === null || item === void 0 ? void 0 : item.quantity
            };
          })) || [],
          price: {
            basePrice: (_this$_cart$priceInfo = (_this$_cart6 = this._cart) === null || _this$_cart6 === void 0 ? void 0 : (_this$_cart6$priceInf = _this$_cart6.priceInfo) === null || _this$_cart6$priceInf === void 0 ? void 0 : _this$_cart6$priceInf.total) !== null && _this$_cart$priceInfo !== void 0 ? _this$_cart$priceInfo : 0,
            currency: ((_this$_cart7 = this._cart) === null || _this$_cart7 === void 0 ? void 0 : (_this$_cart7$priceInf = _this$_cart7.priceInfo) === null || _this$_cart7$priceInf === void 0 ? void 0 : _this$_cart7$priceInf.currencyCode) || "USD",
            voucherCode: ((_this$_cart8 = this._cart) === null || _this$_cart8 === void 0 ? void 0 : _this$_cart8.couponCode) || "",
            voucherDiscount: ((_this$_cart9 = this._cart) === null || _this$_cart9 === void 0 ? void 0 : _this$_cart9.couponDiscount) || "",
            voucherName: ((_this$_cart10 = this._cart) === null || _this$_cart10 === void 0 ? void 0 : _this$_cart10.couponDescription) || "",
            voucherType: ((_this$_cart11 = this._cart) === null || _this$_cart11 === void 0 ? void 0 : _this$_cart11.discountType) || ""
          },
          totalBreadCount: sumOfBreadsticks
        };
      } catch (e) {
        cart = null;
      }

      return cart;
    }
  }, {
    key: "location",
    get: function get() {
      if (!this._restaurantDetail) {
        return null;
      }

      var location = null;

      try {
        var _this$_restaurantDeta, _this$_restaurantDeta2, _this$_restaurantDeta3, _this$_restaurantDeta4, _this$_restaurantDeta5, _this$_restaurantDeta6, _this$_appAttributes, _this$_appAttributes$, _this$_appAttributes$2;

        location = {
          locationInfo: {
            locationId: (_this$_restaurantDeta = this._restaurantDetail) === null || _this$_restaurantDeta === void 0 ? void 0 : _this$_restaurantDeta.locationId,
            restaurantNum: (_this$_restaurantDeta2 = this._restaurantDetail) === null || _this$_restaurantDeta2 === void 0 ? void 0 : _this$_restaurantDeta2.restaurantNum,
            locationName: (_this$_restaurantDeta3 = this._restaurantDetail) === null || _this$_restaurantDeta3 === void 0 ? void 0 : _this$_restaurantDeta3.locationName,
            locationState: (_this$_restaurantDeta4 = this._restaurantDetail) === null || _this$_restaurantDeta4 === void 0 ? void 0 : _this$_restaurantDeta4.locationState,
            locationZip: (_this$_restaurantDeta5 = this._restaurantDetail) === null || _this$_restaurantDeta5 === void 0 ? void 0 : (_this$_restaurantDeta6 = _this$_restaurantDeta5.locationZip) === null || _this$_restaurantDeta6 === void 0 ? void 0 : _this$_restaurantDeta6.substring(0, 5),
            brandName: (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.concept) === null || _this$_appAttributes$ === void 0 ? void 0 : (_this$_appAttributes$2 = _this$_appAttributes$.conceptCodeDesc) === null || _this$_appAttributes$2 === void 0 ? void 0 : _this$_appAttributes$2.toLowerCase()
          }
        };
      } catch (e) {
        location = null;
      }

      return location;
    }
  }, {
    key: "page",
    get: function get() {
      var page = null;
      var sysEnv = process.env.DP_ENV || process.env.NEXT_PUBLIC_DP_ENV;

      try {
        var _window, _window$location, _window$location$path, _this$_pageAnalyticsD, _this$_pageAnalyticsD2, _this$_pageAnalyticsD3, _window2, _window2$location, _window2$location$pat, _window2$location$pat2, _this$platformUtil2, _this$platformUtil3, _this$_appAttributes2, _this$_appAttributes3, _this$_appAttributes4, _this$_appAttributes5, _window3, _this$_pageAnalyticsD4, _this$platformUtil$ge, _this$platformUtil$ge2;

        page = {
          category: {
            menuType: (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : (_window$location$path = _window$location.pathname) === null || _window$location$path === void 0 ? void 0 : _window$location$path.split("/")[2],
            //TODO this does not update b/c SPA
            pageType: ((_this$_pageAnalyticsD = this._pageAnalyticsDetails) === null || _this$_pageAnalyticsD === void 0 ? void 0 : _this$_pageAnalyticsD.productCategoryPageType) || ((_this$_pageAnalyticsD2 = this._pageAnalyticsDetails) === null || _this$_pageAnalyticsD2 === void 0 ? void 0 : _this$_pageAnalyticsD2.pageType),
            //TODO this does not update b/c SPA
            primaryCategory: ((_this$_pageAnalyticsD3 = this._pageAnalyticsDetails) === null || _this$_pageAnalyticsD3 === void 0 ? void 0 : _this$_pageAnalyticsD3.primaryCategory) || ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : (_window2$location$pat = _window2$location.pathname) === null || _window2$location$pat === void 0 ? void 0 : (_window2$location$pat2 = _window2$location$pat.split("/")) === null || _window2$location$pat2 === void 0 ? void 0 : _window2$location$pat2[1])
          },
          pageInfo: {
            destinationURL: (_this$platformUtil2 = this.platformUtil) === null || _this$platformUtil2 === void 0 ? void 0 : _this$platformUtil2.getLocationPathName(),
            //TODO this does not update b/c SPA
            pageName: this._pageAnalyticsDetails ? this._pageAnalyticsDetails.pageName : (_this$platformUtil3 = this.platformUtil) === null || _this$platformUtil3 === void 0 ? void 0 : _this$platformUtil3.getLocationPathName(),
            //TODO this does not update b/c SPA
            siteBrand: (_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.concept) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.conceptCode,
            siteName: (_this$_appAttributes4 = this._appAttributes) === null || _this$_appAttributes4 === void 0 ? void 0 : (_this$_appAttributes5 = _this$_appAttributes4.concept) === null || _this$_appAttributes5 === void 0 ? void 0 : _this$_appAttributes5.conceptCodeDesc,
            siteType: this.platformUtil.PLATFORM_TYPE === PlatformType.APP ? "APP" : ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.innerWidth) < 768 ? "MOBILE" : "WEB",
            sysEnv: sysEnv === "production" ? "PROD" : "development",
            menuType: window.location.pathname.split("/")[2],
            //TODO this does not update b/c SPA
            pageType: (_this$_pageAnalyticsD4 = this._pageAnalyticsDetails) === null || _this$_pageAnalyticsD4 === void 0 ? void 0 : _this$_pageAnalyticsD4.pageType,
            //TODO this does not update b/c SPA
            primaryCategory: window.location.pathname.split("/").join("|"),
            //TODO this does not update b/c SPA
            cacheable: false,
            language: ((_this$platformUtil$ge = this.platformUtil.getHostName()) === null || _this$platformUtil$ge === void 0 ? void 0 : _this$platformUtil$ge.indexOf(".ca")) !== -1 ? "en_CA" : "en_US",
            geoCountry: ((_this$platformUtil$ge2 = this.platformUtil.getHostName()) === null || _this$platformUtil$ge2 === void 0 ? void 0 : _this$platformUtil$ge2.indexOf(".ca")) !== -1 ? "CA" : "US"
          }
        };
      } catch (e) {
        page = null;
      }

      return page;
    }
  }, {
    key: "product",
    get: function get() {
      var product = {};

      try {
        var _this$_pageAnalyticsD5, _this$_pageAnalyticsD6, _this$_menuItemDetail, _this$_menuItemDetail2, _this$_menuItemDetail3, _this$_menuItemDetail4, _this$_menuItemDetail5;

        product = {
          category: {
            menuType: window.location.pathname.split("/")[2],
            pageType: ((_this$_pageAnalyticsD5 = this._pageAnalyticsDetails) === null || _this$_pageAnalyticsD5 === void 0 ? void 0 : _this$_pageAnalyticsD5.productCategoryPageType) || ((_this$_pageAnalyticsD6 = this._pageAnalyticsDetails) === null || _this$_pageAnalyticsD6 === void 0 ? void 0 : _this$_pageAnalyticsD6.pageType),
            primaryCategory: window.location.pathname.split("/").join("|")
          },
          price: {
            basePrice: (_this$_menuItemDetail = this._menuItemDetail) === null || _this$_menuItemDetail === void 0 ? void 0 : _this$_menuItemDetail.price
          },
          productInfo: {
            productId: (_this$_menuItemDetail2 = this._menuItemDetail) === null || _this$_menuItemDetail2 === void 0 ? void 0 : _this$_menuItemDetail2.id,
            productName: (_this$_menuItemDetail3 = this._menuItemDetail) === null || _this$_menuItemDetail3 === void 0 ? void 0 : _this$_menuItemDetail3.name,
            // TODO: validate mapping with new API
            productSku: (_this$_menuItemDetail4 = this._menuItemDetail) === null || _this$_menuItemDetail4 === void 0 ? void 0 : _this$_menuItemDetail4.selectedSKU.optionId,
            productDetails: (_this$_menuItemDetail5 = this._menuItemDetail) === null || _this$_menuItemDetail5 === void 0 ? void 0 : _this$_menuItemDetail5.description
          }
        };
      } catch (e) {
        product = null;
      }

      return product;
    }
  }, {
    key: "user",
    get: function get() {
      var _this$_userDetails, _this$_userDetails2, _this$_userDetails2$p, _this$_userDetails3, _this$_userDetails3$p, _this$sessionIdData;

      var profileInfo = {
        profileID: (_this$_userDetails = this._userDetails) === null || _this$_userDetails === void 0 ? void 0 : _this$_userDetails.userId,
        loginStatus: this.userLoggedInStatus,
        preferredLocation: (_this$_userDetails2 = this._userDetails) === null || _this$_userDetails2 === void 0 ? void 0 : (_this$_userDetails2$p = _this$_userDetails2.preferredRestaurantList) === null || _this$_userDetails2$p === void 0 ? void 0 : _this$_userDetails2$p.atgRestaurantId,
        preferredRestaurantNumber: (_this$_userDetails3 = this._userDetails) === null || _this$_userDetails3 === void 0 ? void 0 : (_this$_userDetails3$p = _this$_userDetails3.preferredRestaurantList) === null || _this$_userDetails3$p === void 0 ? void 0 : _this$_userDetails3$p.restaurantNumber,
        profileType: this.isLoggedIn ? "standard" : "guest",
        profileSource: this.isLoggedIn ? "native" : "non-native",
        sessionID: (_this$sessionIdData = this.sessionIdData) === null || _this$sessionIdData === void 0 ? void 0 : _this$sessionIdData.sessionID
      };
      return {
        profile: {
          profileInfo: profileInfo
        }
      };
    }
  }, {
    key: "deliveryEstimate",
    get: function get() {
      return this._deliveryEstimate;
    }
  }, {
    key: "transaction",
    get: function get() {
      var _lastOrderDetails$ord,
          _lastOrderDetails$ord2,
          _lastOrderDetails$ord3,
          _this16 = this,
          _lastOrderDetails$ord4,
          _lastOrderDetails$ord5,
          _lastOrderDetails$ord6,
          _lastOrderDetails$ord7,
          _lastOrderDetails$ord8,
          _moment3,
          _lastOrderDetails$ord9,
          _lastOrderDetails$ord10,
          _lastOrderDetails$ord11,
          _lastOrderDetails$ord12,
          _lastOrderDetails$ord13,
          _lastOrderDetails$ord14,
          _lastOrderDetails$ord15,
          _lastOrderDetails$ord16,
          _lastOrderDetails$ord17,
          _lastOrderDetails$ord18,
          _lastOrderDetails$ord19,
          _lastOrderDetails$ord20,
          _lastOrderDetails$ord21,
          _lastOrderDetails$ord22,
          _lastOrderDetails$ord23,
          _lastOrderDetails$ord24,
          _lastOrderDetails$ord25,
          _lastOrderDetails$ord26,
          _lastOrderDetails$ord27,
          _lastOrderDetails$ord28,
          _lastOrderDetails$ord29,
          _lastOrderDetails$ord30,
          _lastOrderDetails$ord31,
          _lastOrderDetails$ord32;

      var lastOrderDetails = this._lastOrderDetails;

      if (!this._lastOrderDetails) {
        return {};
      }

      var priceInfo = lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord = lastOrderDetails.order) === null || _lastOrderDetails$ord === void 0 ? void 0 : _lastOrderDetails$ord.priceInfo;
      var sumOfBreadsticks = 0;
      var items = (_lastOrderDetails$ord2 = lastOrderDetails.order) === null || _lastOrderDetails$ord2 === void 0 ? void 0 : (_lastOrderDetails$ord3 = _lastOrderDetails$ord2.commerceItems) === null || _lastOrderDetails$ord3 === void 0 ? void 0 : _lastOrderDetails$ord3.map(function (item) {
        var _item$priceInfo2;

        sumOfBreadsticks += (item === null || item === void 0 ? void 0 : item.quantity) * (item === null || item === void 0 ? void 0 : item.breadCount);

        if (item.subItem) {
          item.subItem.forEach(function (sItem) {
            var subItemBreadCount = sItem === null || sItem === void 0 ? void 0 : sItem.breadCount;
            sumOfBreadsticks += item.quantity * subItemBreadCount;
          });
        }

        var categories = _this16._getCategoriesBasedOnMenuProductId(item === null || item === void 0 ? void 0 : item.productId);

        return {
          quantity: item === null || item === void 0 ? void 0 : item.quantity,
          breadCount: item === null || item === void 0 ? void 0 : item.breadCount,
          category: {
            primaryCategory: "TO GO",
            subCategory1: (categories === null || categories === void 0 ? void 0 : categories[0]) || "",
            subCategory2: (categories === null || categories === void 0 ? void 0 : categories[1]) || ""
          },
          price: {
            basePrice: item === null || item === void 0 ? void 0 : (_item$priceInfo2 = item.priceInfo) === null || _item$priceInfo2 === void 0 ? void 0 : _item$priceInfo2.amount,
            currency: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.currencyCode
          },
          productInfo: {
            productID: item === null || item === void 0 ? void 0 : item.productId,
            sku: item === null || item === void 0 ? void 0 : item.catalogRefId,
            productName: item === null || item === void 0 ? void 0 : item.displayName
          }
        };
      });
      var total = {
        priceTotal: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.total,
        taxTotal: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.tax,
        currency: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.currencyCode,
        basePrice: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.amount,
        deliveryFee: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.fixedFee,
        serviceFee: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.variableFee,
        tipAmount: lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord4 = lastOrderDetails.order) === null || _lastOrderDetails$ord4 === void 0 ? void 0 : (_lastOrderDetails$ord5 = _lastOrderDetails$ord4.paymentDetails) === null || _lastOrderDetails$ord5 === void 0 ? void 0 : (_lastOrderDetails$ord6 = _lastOrderDetails$ord5[0]) === null || _lastOrderDetails$ord6 === void 0 ? void 0 : _lastOrderDetails$ord6.tipAmount
      };
      var transactionStatus = lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord7 = lastOrderDetails.order) === null || _lastOrderDetails$ord7 === void 0 ? void 0 : _lastOrderDetails$ord7.state;
      var attributes = {
        orderSubType: "new",
        orderType: this.getOrderTypeString(lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord8 = lastOrderDetails.order) === null || _lastOrderDetails$ord8 === void 0 ? void 0 : _lastOrderDetails$ord8.orderType),
        pickupTime: (_moment3 = moment(lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord9 = lastOrderDetails.order) === null || _lastOrderDetails$ord9 === void 0 ? void 0 : _lastOrderDetails$ord9.pickupTime, "hh:mm A")) === null || _moment3 === void 0 ? void 0 : _moment3.format("HH:mm:ss"),
        pickupDate: lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord10 = lastOrderDetails.order) === null || _lastOrderDetails$ord10 === void 0 ? void 0 : _lastOrderDetails$ord10.pickupDate,
        pickupType: lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord11 = lastOrderDetails.order) === null || _lastOrderDetails$ord11 === void 0 ? void 0 : (_lastOrderDetails$ord12 = _lastOrderDetails$ord11.shippingGroup) === null || _lastOrderDetails$ord12 === void 0 ? void 0 : _lastOrderDetails$ord12.pickupMethod
      };
      var payment = lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord13 = lastOrderDetails.order) === null || _lastOrderDetails$ord13 === void 0 ? void 0 : (_lastOrderDetails$ord14 = _lastOrderDetails$ord13.paymentGroup) === null || _lastOrderDetails$ord14 === void 0 ? void 0 : _lastOrderDetails$ord14.map(function (item) {
        return {
          paymentCardType: item === null || item === void 0 ? void 0 : item.creditCardType,
          paymentMethod: item === null || item === void 0 ? void 0 : item.paymentMethod,
          paymentCurrency: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.currencyCode,
          paymentAmount: item === null || item === void 0 ? void 0 : item.amount
        };
      });
      var transactionId = lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord15 = lastOrderDetails.order) === null || _lastOrderDetails$ord15 === void 0 ? void 0 : _lastOrderDetails$ord15.orderNumber;
      var deliveryAddress = {
        address1: lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord16 = lastOrderDetails.order) === null || _lastOrderDetails$ord16 === void 0 ? void 0 : (_lastOrderDetails$ord17 = _lastOrderDetails$ord16.shippingGroup) === null || _lastOrderDetails$ord17 === void 0 ? void 0 : _lastOrderDetails$ord17.address1,
        address2: lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord18 = lastOrderDetails.order) === null || _lastOrderDetails$ord18 === void 0 ? void 0 : (_lastOrderDetails$ord19 = _lastOrderDetails$ord18.shippingGroup) === null || _lastOrderDetails$ord19 === void 0 ? void 0 : _lastOrderDetails$ord19.address2,
        city: lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord20 = lastOrderDetails.order) === null || _lastOrderDetails$ord20 === void 0 ? void 0 : (_lastOrderDetails$ord21 = _lastOrderDetails$ord20.shippingGroup) === null || _lastOrderDetails$ord21 === void 0 ? void 0 : _lastOrderDetails$ord21.city,
        state: lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord22 = lastOrderDetails.order) === null || _lastOrderDetails$ord22 === void 0 ? void 0 : (_lastOrderDetails$ord23 = _lastOrderDetails$ord22.shippingGroup) === null || _lastOrderDetails$ord23 === void 0 ? void 0 : _lastOrderDetails$ord23.stateName,
        zip: lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord24 = lastOrderDetails.order) === null || _lastOrderDetails$ord24 === void 0 ? void 0 : (_lastOrderDetails$ord25 = _lastOrderDetails$ord24.shippingGroup) === null || _lastOrderDetails$ord25 === void 0 ? void 0 : _lastOrderDetails$ord25.postalCode
      };
      return {
        item: items,
        total: total,
        transactionStatus: transactionStatus,
        attributes: attributes,
        payment: payment,
        transactionId: transactionId,
        profile: {
          address: {
            country: null,
            postalCode: null,
            stateProvince: null,
            type: null
          }
        },
        coupon: {
          code: (lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord26 = lastOrderDetails.order) === null || _lastOrderDetails$ord26 === void 0 ? void 0 : _lastOrderDetails$ord26.couponCode) || "",
          discount: (lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord27 = lastOrderDetails.order) === null || _lastOrderDetails$ord27 === void 0 ? void 0 : _lastOrderDetails$ord27.couponDiscount) || ""
        },
        totalBreadCount: sumOfBreadsticks.toString(),
        delivery: {
          estimatedTime: this.deliveryEstimate,
          quoteId: lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord28 = lastOrderDetails.order) === null || _lastOrderDetails$ord28 === void 0 ? void 0 : (_lastOrderDetails$ord29 = _lastOrderDetails$ord28.shippingGroup) === null || _lastOrderDetails$ord29 === void 0 ? void 0 : (_lastOrderDetails$ord30 = _lastOrderDetails$ord29.quote) === null || _lastOrderDetails$ord30 === void 0 ? void 0 : _lastOrderDetails$ord30.quoteId,
          deliveryDate: moment().format("MM/DD/YYYY"),
          address: deliveryAddress,
          dropoff: lastOrderDetails === null || lastOrderDetails === void 0 ? void 0 : (_lastOrderDetails$ord31 = lastOrderDetails.order) === null || _lastOrderDetails$ord31 === void 0 ? void 0 : (_lastOrderDetails$ord32 = _lastOrderDetails$ord31.shippingGroup) === null || _lastOrderDetails$ord32 === void 0 ? void 0 : _lastOrderDetails$ord32.deliveryDropOffOption
        }
      };
    }
  }, {
    key: "isLoggedIn",
    get: function get() {
      var _this$_sessionDetails, _this$_sessionDetails2;

      var loggedInStatus = this._sessionDetails ? !((_this$_sessionDetails = this._sessionDetails) !== null && _this$_sessionDetails !== void 0 && (_this$_sessionDetails2 = _this$_sessionDetails.profile) !== null && _this$_sessionDetails2 !== void 0 && _this$_sessionDetails2["transient"]) : false;
      var cloudLoggedInStatus = this.platformUtil.isUserLoggedIn();
      return loggedInStatus && cloudLoggedInStatus;
    }
  }, {
    key: "userLoggedInStatus",
    get: function get() {
      return this.isLoggedIn ? "logged-in" : "logged-out";
    }
    /**
     * dataLayerJSON after cloud migration is not returning from session Details.
     * So construct the dataLayerJSON with local data available for all modules.
     * sessionDetails is set in UserStore
     * restaurantDetails needs to come from respective modules.
     */

  }, {
    key: "dataLayerJSON",
    get: function get() {
      try {
        var _ref3, _this$_cart$orderType, _this$_cart12, _this$_sessionDetails3, _this$_sessionDetails4, _window4, _window4$digitalData;

        var data = {};
        data.orderType = this.getOrderTypeString((_ref3 = (_this$_cart$orderType = (_this$_cart12 = this._cart) === null || _this$_cart12 === void 0 ? void 0 : _this$_cart12.orderType) !== null && _this$_cart$orderType !== void 0 ? _this$_cart$orderType : (_this$_sessionDetails3 = this._sessionDetails) === null || _this$_sessionDetails3 === void 0 ? void 0 : (_this$_sessionDetails4 = _this$_sessionDetails3.orderContext) === null || _this$_sessionDetails4 === void 0 ? void 0 : _this$_sessionDetails4.orderTypeValue) !== null && _ref3 !== void 0 ? _ref3 : 0);

        if (this.location) {
          data.location = this.location;
        }

        if (this.cart) {
          data.cart = this.cart;
        }

        if (this.page) {
          data.page = this.page;
        }

        if (this.product) {
          data.product = this.product;
        }

        if (this.user) {
          data.user = this.user;
        }

        if (this._waitListData) {
          data.waitList = toJS(this._waitListData);
        }

        if (this._curbsideTransactionDetails) {
          data.transaction = toJS(this._curbsideTransactionDetails);
        }

        if (this.transaction) {
          var _this$transaction;

          data.transaction = toJS(this.transaction);
          data.totalBreadCount = (_this$transaction = this.transaction) === null || _this$transaction === void 0 ? void 0 : _this$transaction.totalBreadCount;
        }

        if (this._curbsideDetails) {
          data.curbside = toJS(this._curbsideDetails);
        }

        if ((_window4 = window) !== null && _window4 !== void 0 && (_window4$digitalData = _window4.digitalData) !== null && _window4$digitalData !== void 0 && _window4$digitalData.event) {
          data.event = window.digitalData.event;
        } else {
          data.event = [];
        }

        return data;
      } catch (e) {}
    }
  }, {
    key: "sessionIdData",
    get: function get() {
      return this._sessionIdData;
    }
  }, {
    key: "isEditDelivery",
    get: function get() {
      return this._isEditDelivery;
    },
    set: function set(value) {
      var _this17 = this;

      runInAction(function () {
        _this17._isEditDelivery = value;
      });
    }
  }, {
    key: "isDeliveryFormDirty",
    get: function get() {
      return this._isDeliveryFormDirty;
    },
    set: function set(value) {
      var _this18 = this;

      runInAction(function () {
        _this18._isDeliveryFormDirty = value;
      });
    }
  }]);

  return AnalyticsModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_restaurantDetail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_cart", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_menuItemDetail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_returnWindowDigData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_waitListData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_pageAnalyticsDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_curbsideTransactionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_curbsideDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_changeErrorPageNameWithoutRD", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_lastOrderDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_userDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_sessionIdData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_menuListMap", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_orderNumber", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_deliveryEstimate", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_isDeliveryFormDirty", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_isEditDelivery", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "cart", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "location", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "location"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "page", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "page"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "product", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "product"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "user", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryEstimate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryEstimate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transaction", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "transaction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLoggedIn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoggedIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userLoggedInStatus", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userLoggedInStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dataLayerJSON", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dataLayerJSON"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sessionIdData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sessionIdData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEditDelivery", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEditDelivery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDeliveryFormDirty", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDeliveryFormDirty"), _class.prototype)), _class);
export { AnalyticsModel as default };